import { useTranslation } from "react-i18next"
import { type ProductV2 } from "types"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { fractionalRgbToHex } from "../ColorItem/helpers"
import { ProductCategories } from "components/Navbar/types"

interface ProductPreviewProps {
  data: ProductV2
  setActiveColorIndex?: (color: number) => void
  effectType?: ProductCategories
  activeColorIndex?: number
}

export const ProductPreview = ({
  data,
  setActiveColorIndex,
  effectType,
  activeColorIndex = 0,
}: ProductPreviewProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-3">
      <img
        src={data.cover.length ? data.cover : "/none-image.svg"}
        alt={t("productPreview.imageAlt")}
        className="h-10 w-10 shrink-0 rounded-lg object-cover"
      />
      <div className="min-w-0">
        {effectType !== ProductCategories.GLASSES && (
          <p className="max-w-[120px] truncate text-sm font-medium text-white">
            {data.brand.length ? data.brand : t("productPreview.defaultBrand")}
          </p>
        )}
        <p className="max-w-[120px] truncate text-xs text-white/60">
          {data.name.length ? data.name : t("productPreview.defaultName")}
        </p>
      </div>
      {effectType === ProductCategories.MAKEUP && setActiveColorIndex ? (
        <Select
          value={String(activeColorIndex)}
          onValueChange={(val) => setActiveColorIndex(Number(val))}
        >
          <SelectTrigger className="h-8 w-auto border-white/20 bg-white/10 text-sm text-white hover:bg-white/15">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {data.colors.map((color, indx) => (
              <SelectItem value={String(indx)} key={indx}>
                <div className="flex items-center gap-2">
                  <div
                    className="h-4 w-4 shrink-0 rounded-full border"
                    style={{
                      background:
                        color.color[0] === "#" ? color.color : fractionalRgbToHex(color.color),
                    }}
                  />
                  <span className="text-sm">
                    {t("productPreview.tone", { color: color.color })}
                  </span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : null}
    </div>
  )
}
